import Router from './router'

export {
  Router
}



/** WEBPACK FOOTER **
 ** ./pub/client/router/index.js
 **/